var Backbone = require('backbone');

require('./Content.less');

module.exports = Backbone.View.extend({
    el: '.Content',

    initialize: function () {
        // if there are branding, set topNav position: fixed
        app.vent.on('Branding.onLoad', this.fixedTopNav.bind(this));
    },

    fixedTopNav: function () {
        this.$('.Content-topNav').addClass('Content-topNav--isFixed');
    }
});




//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Content/Content.js
// module id = 151
// module chunks = 0